import { NavLink } from "react-router-dom";
import { getNavLinkClass } from "~/assets/styles/classes/NavLinkClasses";

export const SidebarNavLink = ({
  to,
  label,
  isExpanded,
}: {
  to: string;
  label: string;
  isExpanded: boolean;
}) => (
  <NavLink
    to={to}
    end
    className={({ isActive }) =>
      isExpanded
        ? getNavLinkClass(isActive)
        : "text-white p-2 rounded-md hover:text-[#51E7F9]"
    }
    title={isExpanded ? undefined : label}
  >
    <span
      className={`${
        isExpanded ? "inline" : "hidden"
      } text-[14px] leading-[16px] align-middle flex-1`}
    >
      {label}
    </span>
  </NavLink>
);
